import {cn} from 'src/lib/utils';

type Props = {
  content?: React.ReactNode;
  actions?: React.ReactNode;
  /**
   * For filter-heavy headers: below md the actions drop onto their own
   * right-aligned row beneath the (wrapping) filter content, instead of
   * sitting vertically centered beside a tall stack of wrapped filters.
   */
  stackActionsOnMobile?: boolean;
};

const ActionHeader = (props: Props) => {
  return (
    <div
      className={cn(
        'border-border flex flex-row items-center justify-between border-b p-2 max-md:gap-y-2 max-md:px-3 max-md:py-2',
        props.stackActionsOnMobile && 'max-md:flex-wrap',
      )}
    >
      <div
        className={cn(
          'min-w-0 flex-1 px-4 max-md:px-0',
          props.stackActionsOnMobile && 'max-md:basis-full',
        )}
      >
        {props.content}
      </div>
      <div
        className={cn(
          'ml-auto inline-flex shrink-0 items-center justify-end gap-1.5 px-4 max-md:px-0',
          // On its own mobile row the action group spans the width (still
          // right-aligned), so a flexible action — e.g. Activity's search box —
          // can claim the empty space beside the icons instead of leaving it.
          props.stackActionsOnMobile && 'max-md:w-full',
        )}
      >
        {props.actions}
      </div>
    </div>
  );
};

export default ActionHeader;
